export default "__VITE_ASSET__BnxsdnGS__"